var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPower(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9001 2.7002H17.1001V13.5002H18.9001V2.7002ZM3.6001 18.8995C3.6001 13.2873 6.81065 8.42497 11.4953 6.04896L12.8452 7.39884C8.45657 9.36896 5.4001 13.7773 5.4001 18.8995C5.4001 25.8583 11.0413 31.4995 18.0001 31.4995C24.9589 31.4995 30.6001 25.8583 30.6001 18.8995C30.6001 13.7532 27.5148 9.32756 23.0931 7.37124L24.4454 6.01894C29.1623 8.38385 32.4001 13.2636 32.4001 18.8995C32.4001 26.8524 25.953 33.2995 18.0001 33.2995C10.0472 33.2995 3.6001 26.8524 3.6001 18.8995Z",
    fill: "#none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPower);
export default __webpack_public_path__ + "static/media/power.4869ad4ff1723935e2b65bb3a5e10485.svg";
export { ForwardRef as ReactComponent };